import { createSvgIcon } from "@mui/material";

const ImportDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.1331C0 9.35106 9.55126 -0.200195 21.3333 -0.200195H58.6667C70.4487 -0.200195 80 9.35107 80 21.1331V58.4665C80 70.2486 70.4487 79.7998 58.6667 79.7998H21.3333C9.55126 79.7998 0 70.2486 0 58.4665V21.1331Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M24.8569 32.4544C24.8569 29.5089 27.2447 27.1211 30.1903 27.1211H60.1885C63.134 27.1211 65.5219 29.5089 65.5219 32.4544V57.3657C65.5219 60.3112 63.1341 62.699 60.1885 62.699H30.1903C27.2447 62.699 24.8569 60.3112 24.8569 57.3657V32.4544Z"
      fill="#E8EEF2"
    />
    <path
      d="M31.5558 41.8643L45.5445 41.8643C46.4037 41.8643 47.1001 41.1678 47.1001 40.3087C47.1001 39.4496 46.4037 38.7531 45.5445 38.7531L31.5558 38.7531C30.6967 38.7531 30.0003 39.4496 30.0003 40.3087C30.0003 41.1678 30.6967 41.8643 31.5558 41.8643Z"
      fill="#00A866"
    />
    <path
      d="M49.2426 41.3504C49.7943 40.7398 49.776 39.7974 49.1875 39.2089L42.829 32.8504L42.7708 32.7948C42.1602 32.2433 41.2178 32.262 40.6293 32.8504C40.0409 33.4389 40.0225 34.3812 40.5742 34.9919L40.6293 35.05L45.888 40.3087L40.6293 45.5674C40.0219 46.1749 40.0219 47.1596 40.6293 47.7671C41.2368 48.3745 42.2215 48.3745 42.829 47.7671L49.1875 41.4085L49.2426 41.3504Z"
      fill="#00A866"
    />
    <path
      d="M20.8885 33.7686V26.667C20.8885 25.0716 22.182 23.7782 23.7774 23.7781H56.188C57.7835 23.7781 59.0769 25.0715 59.0769 26.667V53.3146C59.0769 54.91 57.7835 56.2034 56.188 56.2034H23.8121C22.2166 56.2034 20.9232 54.91 20.9232 53.3146V47.7686C20.9232 46.9094 20.2268 46.213 19.3677 46.213C18.5086 46.213 17.8121 46.9094 17.8121 47.7686V53.3146C17.8121 56.6283 20.4984 59.3146 23.8121 59.3146H56.188C59.5017 59.3146 62.188 56.6283 62.188 53.3146V26.667C62.188 23.3533 59.5017 20.667 56.188 20.667H23.7774C20.4638 20.6671 17.7774 23.3534 17.7774 26.667V33.7686C17.7774 34.6276 18.4739 35.324 19.333 35.3241C20.1921 35.3241 20.8885 34.6277 20.8885 33.7686Z"
      fill="#B4C8D3"
    />
  </svg>,
  "ImportDialogIcon"
);

export default ImportDialogIcon;
